<template>
     <div>
         <el-container class="main-container">
             <el-header class="reg-steps-wrap">
                 <el-steps :space="600" :active="regStep" finish-status="success" simple class="reg-steps">
                     <el-step title="填写账号信息"></el-step>
                     <el-step title="填写公司信息"></el-step>
                 </el-steps>
             </el-header>
             <el-main class="reg-wrap">
                 <router-view></router-view>
             </el-main>
         </el-container>


         <el-dialog title="注册须知" :visible.sync="registDialogShow" width="1000px" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" center>

             <div id="regist-dialog">
                <p>大华供应商门户为发布大华集团下属相关单位进行招标、采购、合同履行及履约评价信息的专业网站，是实现大华集团与合作伙伴间信息交互的平台。大华供应商门户的所有权、运营权和解释权等其他与网站相关的权利均归大华（集团）有限公司全权享有。</p>
                <p>供应商（指使用本网站的单位和个人）必须完全、严格遵守本须知条款。供应商通过点击本须知末的“同意”按钮，即表示其已全面了解、认可与接受以下所有条款：</p>
                <p class="regist-dialog-title">一、术语与定义：</p>
                <p>1.公司：指大华（集团）有限公司；</p>
                <p>2.采购方：指在大华供应商门户开展相关招标、采购等活动的大华集团下属相关单位。</p>
                <p>3.网站：指大华供应商门户，网址为“http://cg.dahuahome.com/pc/#/”，含配套手机客户端。</p>
                <p class="regist-dialog-title">二、供应商账号及其管理：</p>
                <p>1.供应商一旦在网站注册成功，将收到一个账号，该账号为网站在网上交易过程中识别供应商的唯一依据。</p>
                <p>2.供应商须妥善保管账号和自行设置的密码，并有权根据操作指示随时变更其账号的密码。</p>
                <p>3.无论其实际上是否将账号和密码提供给他人使用，账号对应的供应商均须对该账号和密码下进行的一切活动和交易事件负责，即凡在网站上凭账号及密码实施的行为，该类行为及其后相关的行为均应当被视为或等同于账号所属供应商的行为并由该供应商自行承担全部后果及责任。</p>
                <p>4.如供应商发现任何非法使用其账号或网站存在安全漏洞的情况，应立即有效通知网站（见网站首页披露联系方式），并对通知之前发生的交易自行承担后果。</p>
                <p>5.供应商申请注册后，公司将根据现有供方资源情况，在确认需补充资源的情况下对其进行入库认证，经认证通过的供应商方可在网站进行交易。</p>
                <p>6.在网站所进行的招投标信息交互（包括但不限于招标邀请、报名、招标文件及随附资料领取、投标文件提交、提疑及解答、询标、洽谈、竞价、中标通知等）、合同履行信息交互（包括但不限于付款申报、变更、签证索赔、结算申报、维修通知、质量保证金申请、违约处罚信息等）及其他与招采、供应商管理相关的信息交互行为（具体以网站已开放的范围为准），在点击、勾选或提交等动作实施后即产生于纸质文件资料相同的法律效力。由于价格、税费或其它信息填写错误等原因导致交易无法执行或给采购方造成损失的，所有的责任、后果均由供应商自行承担。</p>
                <p>7.供应商单独承担其所传输内容的所有责任，并确保其传输资料、填列信息及在网站上进行的任何活动均符合国家相关法律、法规、政策、惯例及公序良俗；供应商行为出现任一不符情况的，公司一经发现将有权做出独立判断并将其列入禁用名录。</p>
                <p>8.基于供应商招投标过程及履约表现等，公司有权将其调整为停用（停用期限酌情确定，下同）、禁用状态；一旦确定调整为停用、禁用状态，该类供应商将无权参与大华集团范围内后续新的招采活动。</p>
                <p>9.对于列入禁用名录的供应商，公司有权取消其账号；取消账号意味大华供应商资格的丧失，但并不意味着取消前所发生未完成交易的撤销，也不能消除取消前交易所带来的任何法律后果。</p>
                <p class="regist-dialog-title">三、供应商资料及其管理：</p>
                <p>1.在申请注册及使用网站提供的服务时，供应商应向网站提供真实、准确、完整的信息及资料；供应商的单位、对接人员等情况有任何变更（包括但不限于证照临近有效期的更换、对接人员调整、经营异常情况通报等），供应商应即时在网站上完成注册资料的更新及维护。</p>
                <p>2.采购方及网站将根据供应商提供的注册资料及合同中约定的联系方式，向供应商发送招标邀请、合同签订及履约涉及的必要通知；凡以电子形式发送的通知，则发送人的邮件系统确认电子邮件发送至收件人的邮件接收系统之日、或即时消息（包括但不限于微信、QQ、手机短信等）软件/服务提供方系统提示发送成功之日视为送达之日。</p>
                <p>3.如供应商提供的资料含有不真实、不准确或侵害第三方权利的信息或未及时更新注册资料的，由此相关的一切后果（包括但不限于采购方指令、通知未传递至更换后人员引发问题等）均由该供应商自行承担；如因此导致公司或采购方经济损失（含行政处罚）、商誉损失等的，该供应商应予以全额赔偿。</p>
                <p>4.公司及采购方对供应商注册资料和交易资料有保密义务（仅限非公开资料）。出于统计分析、内部管理之目的，公司及采购方有权使用供应商资料。在得到供应商许可的情况下，公司及采购方可以将其资料向第三方提供；但即使未得到供应商的明确许可，公司及采购方仍可根据法律规定向有权查询的法定机构提供供应商资料，或根据交易需要向第三方提供必要的客户资料。</p>
                <p class="regist-dialog-title">四、免责及保障条款</p>
                <p>1.免责条款：供应商明确同意其使用网站所存在的所有风险均由供应商自行承担，网站、公司及采购方对任何直接、间接、偶然和特殊的损害（包括但不限于因设备故障、电力故障及通讯故障或者电脑病毒、自然灾害等因素遭受的损失，不正当或非法利用网站招致的损害，供应商提供不正确、不明确的信息或未及时更新信息招致的损害等）均不负责任。供应商同意如其违反有关法律、法规或本协议项下的任何条款而给公司、采购方或其他第三人造成任何损失，该供应商应承担由此造成的所有损害赔偿责任。</p>
                <p>2.保障条款：供应商同意保障和维护网站及其他供应商的利益，负责支付供应商违反服务条款引发的违约金及损害赔偿费用、他人使用供应商的账号和密码引发的损害赔偿费用和因其它侵权而产生的损害赔偿费用及追索费。</p>
                <p class="regist-dialog-title">五、廉洁承诺及投诉、举报渠道：</p>
                <p>1.供应商申请成为大华合作伙伴，应保证自身员工了解以下廉洁承诺内容，并遵照执行：</p>
                <p class="indent">(1)不为采购方人员报销其个人费用，不以任何形式赠送实物、现金或礼券或其他财产性利益的形式向采购方人员行贿；</p>
                <p class="indent">(2)不宴请采购方人员，不邀请采购方人员外出旅游或进入营业性娱乐场所。</p>
                <p class="indent">(3)不接受采购方人员介绍的家属或亲友从事与合同相关的业务。</p>
                <p class="indent">(4)不为采购方人员住房装修、婚丧嫁娶、家属和子女的工作安排以及出国等提供方便。</p>
                <p class="indent">(5)不做上述承诺以外其他违反廉洁合作的行为。</p>
                <p>2.供应商有义务就采购方人员任何形式的索贿或受贿行为及时举报；如供应商向采购方人员行贿，或采购方人员向供应商索贿、供应商满足其要求且并未举报的，一经查实，除追回由此给采购方造成的损失外，供应商承诺按相应合同总价的10%向采购方支付违约金，并对本方知情不报人员进行相应处罚。如因供应商及或其员工在合同履行期间贿赂采购方人员，采购方有权取消或终止合同的履行，由此给采购方造成的损失由供应商负责赔偿，且有权将该供应商纳入禁用名录、永不合作。</p>
                <p>3.公司接受实名或匿名举报，并对举报者的信息保密，举报受理部门为大华集团审计部，举报统一受理邮箱为jubao@dahuahome.com。</p>
                <p>4.供应商对于采购方相关业务流程或人员履职情况等如有建议或需投诉的，可以邮件方式提交至大华集团成本招采中心，统一受理邮箱为tousu@dahuahome.com。</p>
                <p class="regist-dialog-title">六、条款解释、法律适用及争议解决</p>
                <p>1.本须知解释权归大华（集团）有限公司。</p>
                <p>2.本须知条款是对供应商与采购方相关协议和约定的补充而非替代；凡涉及与网上交易活动相关的内容，均以本须知条款为准。</p>
                <p>3.如发生本须知条款与中华人民共和国法律相抵触时，则相关条款将按法律规定重新解释，但其它条款仍保持对供应商的约束力。任何情形下，对于任何与上述条款相关的争议，均只适用中华人民共和国法律，并只接受公司所在地人民法院（即上海市宝山区人民法院）的司法管辖。</p>
                <p class="regist-dialog-title">温馨提示：</p>
                <p>注册网站需提供如下证照及资料扫描件：营业执照、资质证书（如拟提供产品/服务类别需要的）、安全生产许可相关证照（如拟提供产品/服务类别需要的）、可证明近三年业绩的资料（含重点合同文档），烦请提前备齐；</p>
                <p>烦请下载下方《注册确认函》模板，填列完整后由公司盖章、法定代表人签名后上传扫描件，其纸质原件应于认证阶段（收到网站提交通知之日起三个工作日内）寄达网站联系人。</p>
                <p>以上资料将予重点审核，若有误或不全将无法通过注册审核。</p>
                <p><a :href="utilBaseUrl +'pc/static/registrationLetter.docx'" target="_blank" style="color:#F28619;">《大华供应商门户注册及使用承诺函》模板</a></p>
             </div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="$router.push('/')">不 接 受</el-button>
                <el-button v-if="registDialogTime>0" type="primary">请阅读 {{ registDialogTime }}s</el-button>
                <el-button v-else type="primary" @click="registDialogShow=false">承诺并接受</el-button>
            </span>
         </el-dialog>



     </div>
</template>

<script type="text/babel">
import { mapGetters } from 'vuex'
import util from '@/util'

export default {
    name: 'Register',
    data () {
        return {
            utilBaseUrl: util.baseUrl.replace(':9007', ':11020'),
            activeIndex: '1',
            registDialogShow: true,
            registDialogTime: 30,
            registDialogTimer: null
        }
    },
    computed: mapGetters(['regStep', 'basic']),
    methods: {
        handleSelect () {},
        handleOpen () {},
        handleClose () {}
    },
    created () {
        this.$root.navs = [{name: '注册', path: '/register'}]
        this.$root.headImage.height = ''
        this.basic.id = ''

        this.registDialogTimer = setInterval(() => {
            this.registDialogTime--
            if (this.registDialogTime <= 0) {
                clearInterval(this.registDialogTimer)
            }
        }, 1000)
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="postcss" scoped>
@import '../../../assets/common.css';

.reg-wrap{
    width: 950px;
    margin: 0 auto 20px;
    @apply --inputBorder;
}
.reg-steps{
    margin-bottom: 20px;
}
.reg-steps-wrap{
    width: 800px;
    margin: 20px auto;
}


#regist-dialog p {
    text-indent: 24px;
    padding: 0 24px;
    text-align: justify;
}

#regist-dialog p.regist-dialog-title {
    text-indent: 0;
    font-weight: bold;
}

#regist-dialog p.indent {
    text-indent: 48px;
}

</style>



// WEBPACK FOOTER //
// src/pages/dsp/register/Register.vue